import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/job-title-translator/JobTitleContent.tsx");
